import React from 'react';

const App: React.FC = () => {
  return <footer className="footer">Copyright © Koloó 2020.</footer>;
};

export default App;
